import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../Actions/AxiosInstance";
import addressEmployee from "../../../../Assets/Images/addressEmployee.svg";
import If from "../../../../Component/Common/If";
import createstore from "../../../../store";
import { convertDateForBackend } from "../../../../Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  // dense: {
  //     marginTop: 16,
  // },
  colorSwitchBase: {
    color: "#166ab3",
    "&$colorChecked": {
      color: "#166ab3",
      "& + $colorBar": {
        backgroundColor: "#666",
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    "&$iOSChecked": {
      color: "#166ab3",
      backgroundColor: "#166ab3",
      "& + $iOSBar": {
        backgroundColor: "#666",
      },
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: "translateX(15px)",
    "& + $iOSBar": {
      opacity: 1,
      border: "none",
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: "solid 1px",
    // borderColor: theme.palette.grey[400],
    // backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(45deg)",
  },

  educationGrades: [],
  allEducationalDetails: [],
});

class WorkExpComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datareceived: false,
      showform: false,
      isShuffle: false,
      maxDate: new Date(),
      rangeDate: [],
      allEducationalDetails: [],
      educationGrades: [],
      country: [],
      stateprovince: [],
      cityzone: [],
      workroles: [],
      allExperienceDetails: [],
      educationgradeid: "",
      institutename: "",
      universityname: "",
      fromdate: "",
      todate: "",
      workroleid: "",
      selectedworkrole: {},
      companyname: "",
      companyaddress: "",
      countryid: "",
      selectedCountry: {},
      stateid: "",
      selectedState: {},
      cityid: "",
      selectedCity: {},
      companydoj: "",
      separationdate: "",
      isEdit: false,
      defaultExpMsg: true,
      defaultEduMsg: true,
      EditPerticularEdu: false,
      EditPerticularExp: false,
      hideButton: false,
      minDate: new Date("01-01-1900"),

      isbuttonDisabled: false,
      currentEdit: "",
      expanded: "false",
      flag: 0,
      showBtn: false,
    };
    this.getIntroComponent = this.getIntroComponent.bind(this);
    this.getViewComponent = this.getViewComponent.bind(this);
    this.getEditComponent = this.getEditComponent.bind(this);
    // this.DelProformaInvoice=this.DelProformaInvoice.bind(this);
    this.EditExp = this.EditExp.bind(this);
  }

  componentDidMount() {
    this.getCountry();
    this.GetWorkRole();
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat =
      typeof DateFormat === "string" ? DateFormat.split(" ") : [""];
    ShortDateFormat = ShortDateFormat[0];
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    let hideButton;
    colleagueid && colleagueid != employeeid
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        ShortDateFormat,
        colleagueid,
        hideButton,
      },
      () => {
        this.GetExperienceDetails();
        // this.state.isShuffle ? this.GetExperienceDetails() : this.GetEducationalDetails();
      },
    );
  }

  handleChange(event) {
    // console.log(this.state.currentEdit);
    this.setState({ currentEdit: event.target.value, isEdit: false });
  }

  ClearAll() {
    this.setState({
      educationgradeid: "",
      institutename: "",
      universityname: "",
      fromdate: "",
      todate: "",
      workroleid: "",
      selectedworkrole: { displayname: "Select Work Role", displayvalue: "" },
      companyname: "",
      companyaddress: "",
      countryid: "",
      selectedCountry: { displayname: "Select Country", displayvalue: "" },
      stateid: "",
      selectedState: { displayname: "Select State", displayvalue: "" },
      cityid: "",
      selectedCity: { displayname: "Select City", displayvalue: "" },
      companydoj: "",
      separationdate: "",
      perticularExp: {},
      EditPerticularEdu: false,
      EditPerticularExp: false,
      flag: false,
    });
  }

  UpdateSelectedId(name, e) {
    this.setState({ [name]: e.target.value });
  }

  UpdateData(name, e) {
    this.setState({ [name]: e.target.value });
  }

  UpdateSelectedDropdownItem(name, HtField, selectedItem) {
    if (name === "countryid") {
      this.setState(
        {
          countryid: selectedItem.displayvalue,
          selectedCountry: selectedItem,
          stateid: "",
          cityid: "",
          selectedState: { displayname: "Select State", displayvalue: "" },
          selectedCity: { displayname: "Select City", displayvalue: "" },
        },
        () => {
          this.getState();
          this.getCity();
        },
      );
    }
    if (name === "stateid") {
      this.setState(
        {
          stateid: selectedItem.displayvalue,
          selectedState: selectedItem,
          cityid: "",
          selectedCity: { displayname: "Select City", displayvalue: "" },
        },
        () => {
          this.getCity();
        },
      );
    }
    if (name === "cityid") {
      this.setState({
        cityid: selectedItem.displayvalue,
        selectedCity: selectedItem,
      });
    }
    if (name === "workroleid") {
      this.setState({
        workroleid: selectedItem.displayvalue,
        selectedworkrole: selectedItem,
      });
    }
  }

  closeDate(args) {
    if (!args.date) {
      return;
    }
    const date = args.date.split(" - ");
    const startdate = date[0].trim();
    const enddate = date[1].trim();
    this.setState({ startdate, enddate });
  }

  expDate(args) {
    if (!args.date) {
      return;
    }
    const date = args.date.split(" - ");
    const companydoj = date[0].trim();
    const separationdate = date[1].trim();
    this.setState({ companydoj, separationdate });
  }

  Deleteconfirmation(item) {
    console.log(item);
    this.setState({ isEdit: "false" });
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",

      action: [
        <Button
          color="inherit"
          size="small"
          onClick={
            item.companyname
              ? this.DeleteExp.bind(this, item)
              : this.DeleteEdu.bind(this, item)
          }
        >
          Delete
        </Button>,
        // :this.DeleteEdu.bind(this, item)
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            this.setState({ isEdit: false });
            this.props.closeSnackbar();
          }}
        >
          Dismiss
        </Button>,
      ],
    });
  }

  OnConform = () => {
    this.setState({
      flag: !this.state.flag,
      expanded: true,
      showform: !this.state.showform,
      isEdit: !this.state.isEdit,
      showBtn: true,
    });
  };

  getCountry() {
    instance
      .get("superuser/allcountry")
      .then((result) => {
        const country = [];
        country.push(
          { displayname: "Select Country", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ country });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getState() {
    const exp = this.state.perticularExp || {};
    if (this.state.countryid) {
      const URL = `superuser/statebycountryid/${this.state.countryid}`;
      instance
        .get(URL)
        .then((result) => {
          const stateprovince = [];
          stateprovince.push(
            { displayname: "Select State", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ stateprovince }, () => {
            // this.setState({ selectedState: stateprovince.find(x => x.displayvalue == exp.stateid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      let cityzone;
      const stateprovince = [
        {
          displayname: "Select State",
          displayvalue: "",
        },
      ];
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ stateprovince, cityzone }, () => {
        // this.setState({ selectedState: this.state.stateprovince.find(x => x.displayvalue == exp.stateid) })
      });
    }
  }

  getCity() {
    const exp = this.state.perticularExp || {};
    if (this.state.stateid && this.state.countryid) {
      const URL = `superuser/citybystateid/${this.state.stateid}`;
      instance
        .get(URL)
        .then((result) => {
          const cityzone = [];
          cityzone.push(
            { displayname: "Select City", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ cityzone }, () => {
            // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == exp.cityid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      let cityzone;
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ cityzone }, () => {
        // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == exp.cityid) })
      });
    }
  }

  GetWorkRole() {
    instance
      .get("superuser/workrole")
      .then((result) => {
        const workroles = [];
        workroles.push(
          { displayname: "Select work roles", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ workroles });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  AddExperienceDetails() {
    this.setState({ isbuttonDisabled: true });
    const data = {
      employeeexperienceid: this.state.employeeexperienceid,
      workroleid: this.state.workroleid,
      companyname: this.state.companyname,
      companyaddress: this.state.companyaddress,
      countryid: this.state.countryid,
      stateid: this.state.stateid,
      cityid: this.state.cityid,
      companydoj: convertDateForBackend(this.state.companydoj),
      separationdate: this.state.separationdate,
    };
    if (!createstore.getState().AuthenticationAction.IsFulfilled) {
      Object.assign(data, {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      });
    }
    const URL = "employee/insertupdateempexperience";
    instance
      .post(URL, data)
      .then((result) => {
        this.setState(
          {
            isEdit: false,
            defaultExpMsg: false,
            workroleid: "",
            employeeexperienceid: "",
            companyname: "",
            companyaddress: "",
            countryid: "",
            stateid: "",
            cityid: "",
            companydoj: new Date(),
            separationdate: new Date(),
            selectedworkrole: {
              displayname: "Select Work Role",
              displayvalue: "",
            },
            selectedCountry: {
              displayname: "Select Country",
              displayvalue: "",
            },
            selectedState: { displayname: "Select State", displayvalue: "" },
            selectedCity: { displayname: "Select City", displayvalue: "" },
            EditPerticularExp: false,
            perticularExp: {},
          },
          () => {
            this.GetExperienceDetails();
            this.props.UpdateStrength(true);
            this.setState({ isbuttonDisabled: false });
          },
        );
      })
      .catch((error) => {
        this.setState({ isbuttonDisabled: false });
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetExperienceDetails() {
    const URL = "employee/getempallexperience";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let allExperienceDetails = [];
        result.data.result.length > 0
          ? (allExperienceDetails = result.data.result)
          : (allExperienceDetails = []);
        const flag = allExperienceDetails.length != 0 ? 0 : 1;
        this.setState({ allExperienceDetails, datareceived: true, flag });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  EditExp = (item, currentEdit) => {
    this.getCountry();
    this.GetWorkRole();
    this.setState(
      {
        perticularExp: item,
        employeeexperienceid: item.employeeexperienceid,
        workroleid: item.workroleid,
        companyname: item.companyname,
        companyaddress: item.companyaddress,
        countryid: item.countryid,
        stateid: item.stateid,
        cityid: item.cityid,
        companydoj: item.companydoj,
        separationdate: item.separationdate,
        isEdit: true,
        currentEdit: "experience",
        EditPerticularExp: true,
        flag: true,
      },
      () => {
        const selectedCountry = this.state.country.find(
          (x) => x.displayvalue == item.countryid,
        );
        const selectedworkrole = this.state.workroles.find(
          (x) => x.displayvalue == item.workroleid,
        );
        this.setState({ selectedCountry, selectedworkrole });
        if (item.countryid) {
          this.getState();
          setTimeout(
            () =>
              this.setState({
                selectedState: this.state.stateprovince.find(
                  (x) => x.displayvalue == item.stateid,
                ),
              }),
            300,
          );
        }
        if (item.stateid) {
          this.getCity();
          setTimeout(
            () =>
              this.setState({
                selectedCity: this.state.cityzone.find(
                  (x) => x.displayvalue == item.cityid,
                ),
              }),
            300,
          );
        }
      },
    );
  };

  DeleteExp(item) {
    this.props.closeSnackbar();
    let data;
    // if (createstore.getState().AuthenticationAction.IsFulfilled) {
    //   data = {};
    // } else {
    //   data = {
    //     // "accountid": this.state.accountid,
    //     // "subscriptionid": this.state.subscriptionid,
    //     timezoneid: this.state.countrytimezoneid,
    //     employeeid: this.props.colleagueid || this.state.employeeid,
    //   };
    // }
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    const URL = `/employee/deleteempexperience/${item.employeeexperienceid}`;
    instance
      .post(URL, data)
      .then((result) => {
        this.setState(
          {
            perticularExp: {},
            employeeexperienceid: "",
            workroleid: "",
            companyname: "",
            companyaddress: "",
            countryid: "",
            stateid: "",
            cityid: "",
            companydoj: new Date(),
            separationdate: new Date(),
            selectedworkrole: {
              displayname: "Select Work Role",
              displayvalue: "",
            },
            selectedCountry: {
              displayname: "Select Country",
              displayvalue: "",
            },
            selectedState: { displayname: "Select State", displayvalue: "" },
            selectedCity: { displayname: "Select City", displayvalue: "" },
            EditPerticularExp: false,
            isEdit: false,

            // country : [],
            // stateprovince : [],
            // cityzone : []
          },
          () => {
            this.props.enqueueSnackbar("deleted successfully", {
              variant: "success",
            });
            this.GetExperienceDetails();
            this.props.UpdateStrength(true);
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  SetFlag = (flagData) => {
    this.setState({
      flag: flagData,
    });
  };

  getIntroComponent() {
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={6} sm={12}>
            <div className="inner-tab-bg">
              <img src={addressEmployee} height="350" />
            </div>
            <div className="inner-tab-cont">
              <div>
                <h4 className="address-head">
                  <FormattedMessage id="LbHeykin" defaultMessage="Hey," />
                  {/* &nbsp;{this.state.ProfileBasicInfo.firstname} */}
                </h4>
                <p className="address-subhead">
                  <FormattedMessage
                    id="LbStartfillingyourdetails"
                    defaultMessage="Start filling your details"
                  />
                </p>
              </div>

              <div className="form-btn 140" onClick={() => this.SetFlag(1)}>
                <span>ADD</span>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }

  getViewComponent() {
    return <div>view.........................1</div>;
  }

  getEditComponent() {
    return <div>edit.........................2</div>;
  }

  render() {
    const { classes, theme } = this.props;
    const { ShortDateFormat, flag, datareceived } = this.state;
    return (
      <div>
        <If condition={datareceived}>
          <If condition={flag == 0}>{this.getIntroComponent()}</If>
          <If condition={flag == 1}>{this.getViewComponent()}</If>
          <If condition={flag == 2}>{this.getEditComponent()}</If>
        </If>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withSnackbar(WorkExpComponent),
);
